import { ApiData, getEntitiesPerStoreAsync, Query, ReportResource, Result } from '../Reports';

import { ApiPaymentsAggregate, ApiPaymentsField, PaymentInfo } from './types';

export const mapApiDataToPaymentInfo = (apiData: ApiData): PaymentInfo => ({
  amount: Number(apiData[ApiPaymentsField.PaymentAmount]),
  nbPayments: Number(apiData[ApiPaymentsField.PaymentCount]),
  paymentMethod: String(apiData[ApiPaymentsField.PaymentMethod]),
  cashbackCount: Number(apiData[ApiPaymentsField.CashbackCount]),
  cashbackAmount: Number(apiData[ApiPaymentsField.CashbackAmount]),
  amountNoCashback: Number(apiData[ApiPaymentsField.PaymentAmountNoCashback]),
  countNoCashback: Number(apiData[ApiPaymentsField.PaymentCountNoCashback]),
});

export const getPaymentsPerStoreAsync = async (query: Query): Promise<Result<PaymentInfo>> =>
  getEntitiesPerStoreAsync<PaymentInfo>(
    {
      ...query,
      resource: ReportResource.Payments,
      aggregates: [ApiPaymentsAggregate.PaymentMethod],
      closedTillLimitation: true,
    },
    mapApiDataToPaymentInfo,
  );
